import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deletePaymentMethod } from '../../../../actions';

const PaymentMethodDeleteButton = ({
  dispatchDeletePaymentMethod,
  paymentMethodId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeletePaymentMethod({ paymentMethodId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

PaymentMethodDeleteButton.propTypes = {
  dispatchDeletePaymentMethod: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  paymentMethodId: PropTypes.number.isRequired,
};

PaymentMethodDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeletePaymentMethod: deletePaymentMethod,
};

export default connect(null, mapDispatchToProps)(PaymentMethodDeleteButton);
